import React, { useCallback } from 'react';
import { styled } from '@compiled/react';
import Button, { ButtonGroup } from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import InlineDialog from '@atlaskit/inline-dialog';
import { token } from '@atlaskit/tokens';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import {
	boardIssueMoveExecute,
	boardIssueMoveCancel,
} from '../../../state/actions/board-issue-move/index.tsx';
import { useBacklogDispatch, useBacklogSelector } from '../../../state/index.tsx';
import { isDialogOpen } from '../../../state/selectors/board-issue-move/index.tsx';
import messages from './messages.tsx';

const BoardIssueMoveDialog = () => {
	const { formatMessage } = useIntl();
	const dispatch = useBacklogDispatch();

	const isOpen = useBacklogSelector(isDialogOpen);

	// Strip arguments from event handlers
	const handleConfirm = useCallback(() => dispatch(boardIssueMoveExecute()), [dispatch]);

	const handleCancel = useCallback(() => dispatch(boardIssueMoveCancel()), [dispatch]);

	return (
		<AbsolutePosition>
			<InlineDialog
				content={
					<Container>
						<Heading as="h5" size="xsmall">
							{formatMessage(messages.title)}
						</Heading>
						<DescriptionStyle>
							{formatMessage(
								expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
									? messages.descriptionIssueTermRefresh
									: messages.description,
							)}
						</DescriptionStyle>
						<ButtonGroup>
							<Button onClick={handleConfirm} appearance="primary">
								{formatMessage(messages.confirm)}
							</Button>
							<Button onClick={handleCancel} appearance="subtle">
								{formatMessage(messages.cancel)}
							</Button>
						</ButtonGroup>
					</Container>
				}
				isOpen={isOpen}
			>
				<div />
			</InlineDialog>
		</AbsolutePosition>
	);
};

export default BoardIssueMoveDialog;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	whiteSpace: 'normal',
	font: token('font.body'),
	width: '250px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DescriptionStyle = styled.p({
	marginBottom: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AbsolutePosition = styled.div({
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > div': {
		position: 'absolute',
		top: token('space.400', '32px'),
	},
});
